import{a as g}from"./chunk.2AIXLGYE.js";import{a as l}from"./chunk.NFEB7TIJ.js";import{a as c}from"./chunk.XPINZPW5.js";import{a}from"./chunk.65JZXZ5X.js";import{a as i}from"./chunk.5456T7GL.js";import{a as n}from"./chunk.LWUQDFQZ.js";import{c as t}from"./chunk.NWIV65VP.js";import{html as m}from"lit";import{property as r,query as _,state as b}from"lit/decorators.js";import{classMap as p}from"lit/directives/class-map.js";import{ifDefined as h}from"lit/directives/if-defined.js";import{live as f}from"lit/directives/live.js";import{css as u}from"lit";var s=u`
  ${g}

  :host {
    --height: var(--he-form-control-toggle-size);
    --thumb-size: 12px;
    --width: 40px;

    display: inline-block;
  }

  .toggle {
    align-items: center;
    font-family: var(--he-form-control-font-family);
    font-size: var(--he-form-control-font-size);
    line-height: var(--he-line-height-normal);
    color: var(--he-form-control-color);
    vertical-align: middle;
    cursor: pointer;
  }

  .toggle__control-wrapper {
    display: inline-flex;
  }

  .toggle__control {
    flex: 0 0 auto;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--width);
    height: var(--height);
    background-color: var(--he-color-neutral-0);
    border: solid var(--he-form-control-border-width) var(--he-form-control-border-color);
    border-radius: var(--height);
    transition: 250ms border-color, 250ms background-color;
  }

  .toggle__control .toggle__thumb {
    width: var(--thumb-size);
    height: var(--thumb-size);
    background-color: var(--he-color-neutral-600);
    border-radius: 50%;
    transition: 250ms transform ease, 250ms background-color, 250ms border-color, 250ms box-shadow;
  }

  .toggle--ltr .toggle__thumb {
    transform: translateX(calc((var(--width) - var(--height)) / -2));
  }

  .toggle--rtl .toggle__thumb {
    transform: translateX(calc((var(--width) - var(--height)) / 2));
  }

  .toggle__input {
    position: absolute;
    opacity: 0;
    padding: 0;
    margin: 0;
    pointer-events: none;
  }

  .toggle:not(.toggle--checked) .toggle__checked-message,
  .toggle--checked .toggle__unchecked-message {
    display: none;
  }

  .toggle__checked-message,
  .toggle__unchecked-message {
    margin-inline-start: var(--he-spacing-x-small);
    user-select: none;
  }

  /* Hover */
  .toggle:not(.toggle--checked):not(.toggle--disabled) .toggle__control:hover {
    border-color: var(--he-color-neutral-900);
  }

  .toggle:not(.toggle--checked):not(.toggle--disabled) .toggle__control:hover .toggle__thumb {
    background-color: var(--he-color-neutral-900);
  }

  /* Checked */
  .toggle--checked .toggle__control {
    background-color: var(--he-color-primary-600);
    border-color: var(--he-color-primary-600);
  }

  .toggle--checked .toggle__control .toggle__thumb {
    background-color: var(--he-color-neutral-0);
    border-color: var(--he-color-primary-600);
  }

  .toggle--checked.toggle--ltr .toggle__thumb {
    transform: translateX(calc((var(--width) - var(--height)) / 2));
  }

  .toggle--checked.toggle--rtl .toggle__thumb {
    transform: translateX(calc((var(--width) - var(--height)) / -2));
  }

  /* Checked + hover */
  .toggle.toggle--checked:not(.toggle--disabled) .toggle__control:hover {
    background-color: var(--he-color-primary-600);
    border-color: var(--he-color-primary-600);
  }

  .toggle.toggle--checked:not(.toggle--disabled) .toggle__control:hover .toggle__thumb {
    background-color: var(--he-color-neutral-0);
  }

  /* Focus */
  .toggle:not(.toggle--disabled) .toggle__input:focus-visible ~ .toggle__control-wrapper {
    outline: solid var(--he-focus-ring-width) var(--he-focus-ring-color);
    outline-offset: 1px;
  }

  /* Disabled */
  .toggle--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .toggle__label {
    color: var(--he-type-primary);
    cursor: pointer;
    font-size: var(--he-form-control-label-font-size);
    line-height: var(--he-line-height-normal);
    font-weight: var(--he-font-weight-semibold);
    margin-bottom: var(--he-spacing-2x-small);
    user-select: none;
  }

  :host([required]) .toggle__label::after {
    content: var(--he-form-control-required-content);
    margin-inline-start: var(--he-form-control-required-content-offset);
  }

  @media screen and (forced-colors: active) {
    .toggle__control .toggle__thumb {
      transition: none;
    }

    .toggle__control,
    .toggle--checked .toggle__control,
    .toggle:not(.toggle--checked):not(.toggle--disabled) .toggle__control:hover,
    .toggle.toggle--checked:not(.toggle--disabled) .toggle__control:hover {
      background-color: ${l.ButtonFace};
      border-color: ${l.ButtonBorder};
    }

    .toggle__control .toggle__thumb,
    .toggle:not(.toggle--checked):not(.toggle--disabled) .toggle__control:hover .toggle__thumb {
      background-color: ${l.ButtonText};
    }

    .toggle--checked .toggle__control .toggle__thumb,
    .toggle.toggle--checked:not(.toggle--disabled) .toggle__control:hover .toggle__thumb {
      background-color: ${l.Highlight};
    }

    /* Disabled */
    .toggle--disabled {
      opacity: 1;
    }

    .toggle--disabled .toggle__control {
      background-color: ${l.ButtonFace};
      border-color: ${l.GrayText};
    }

    .toggle--disabled .toggle__control .toggle__thumb {
      background-color: ${l.GrayText};
    }
  }
`;var e=class extends a{constructor(){super(...arguments);this.formSubmitController=new n(this,{value:o=>o.checked?o.value:void 0,defaultValue:o=>o.defaultChecked,setValue:(o,d)=>o.checked=d});this.hasFocus=!1;this.label="";this.disabled=!1;this.checked=!1;this.defaultChecked=!1}click(){this.input.click()}focus(o){this.input.focus(o)}blur(){this.input.blur()}handleBlur(){this.hasFocus=!1,this.emit("he-blur")}handleCheckedChange(){this.input.checked=this.checked}handleClick(){this.checked=!this.checked,this.emit("he-change")}handleFocus(){this.hasFocus=!0,this.emit("he-focus")}handleKeyDown(o){o.key==="ArrowLeft"&&(o.preventDefault(),this.checked=!1,this.emit("he-change")),o.key==="ArrowRight"&&(o.preventDefault(),this.checked=!0,this.emit("he-change"))}render(){return m`
      <label
        part="base"
        class=${p({toggle:!0,"toggle--checked":this.checked,"toggle--disabled":this.disabled,"toggle--focused":this.hasFocus,[`toggle--${this.dir}`]:!0})}
      >
        <input
          class="toggle__input"
          type="checkbox"
          name=${h(this.name)}
          value=${h(this.value)}
          .checked=${f(this.checked)}
          .disabled=${this.disabled}
          role="switch"
          aria-checked=${this.checked?"true":"false"}
          aria-labelledby="label"
          @click=${this.handleClick}
          @blur=${this.handleBlur}
          @focus=${this.handleFocus}
          @keydown=${this.handleKeyDown}
        />

        <div part="label" id="label" class="toggle__label">
          <slot name="label">${this.label}</slot>
        </div>

        <div class="toggle__control-wrapper">
          <span part="control" class="toggle__control">
            <span part="thumb" class="toggle__thumb"></span>
          </span>

          <span part="checked-message" class="toggle__checked-message">
            <slot name="checked-message">${this.localize.term("on")}</slot>
          </span>

          <span part="unchecked-message" class="toggle__unchecked-message">
            <slot name="unchecked-message">${this.localize.term("off")}</slot>
          </span>
        </div>
      </label>
    `}};e.styles=s,e.baseName="toggle",e.reactEvents={onHeBlur:new CustomEvent("he-blur"),onHeChange:new CustomEvent("he-change"),onHeFocus:new CustomEvent("he-focus")},t([_('input[type="checkbox"]')],e.prototype,"input",2),t([b()],e.prototype,"hasFocus",2),t([r()],e.prototype,"label",2),t([r()],e.prototype,"name",2),t([r()],e.prototype,"value",2),t([r({type:Boolean,reflect:!0})],e.prototype,"disabled",2),t([r({type:Boolean,reflect:!0})],e.prototype,"checked",2),t([i("checked")],e.prototype,"defaultChecked",2),t([c("checked",{waitUntilFirstUpdate:!0})],e.prototype,"handleCheckedChange",1);var G=e;export{e as a,G as b};
